
export default {
    data() {
        return {
            images: [1, 2, 3, 4, 5, 6, 7, 8],
        };
    },
    methods: {
        getImagePath(image) {
            return require(`@/assets/images/roadshow-italy/partner_${image}.png`);
        },
    },
};
